import { MAX_PEOPLE_IN_SPACE } from "constants/constants";
import { throttle } from "lodash";
import React, { useEffect, useMemo, useRef } from "react";
import { useSelector } from "react-redux";
import { createHtmlPortalNode, InPortal } from "react-reverse-portal";
import { setGridSize } from "slices/generalSlice";
import {
  selectBigLuids,
  selectSmallLuids,
  selectSpaceSideBar,
} from "slices/spaceMediaSlice";
import { selectMeSharing } from "slices/spaceMyMediaSlice";
import BigVideoCloser from "./BigVideoCloser/BigVideoCloser";
import MediaContainer from "./MediaContainer/MediaContainer";
import MyBoard from "./MyBoard/MyBoard";
import RenderedOutPortals from "./RenderedOutPortals/RenderedOutPortals";
let dispatch = null;
// let getState = null;
import("Store").then((module) => {
  dispatch = module.store.dispatch;
  // getState = module.store.getState;
});

export const REMOTE_VIDEO_CONTAINER = "remote-video-container";
export const GRIDMEN_CONTAINER = "gridmen-container";

const throttleGridResize = throttle(
  () => {
    let elem = document.getElementById(GRIDMEN_CONTAINER);
    if (elem) {
      dispatch(
        setGridSize({
          width: elem.getBoundingClientRect().width,
          height: elem.getBoundingClientRect().height,
        })
      );
    }
  },
  200,
  { leading: false, trailing: true }
);

const RemoteMedia = () => {
  // window.efs_debug && window.log("REMOTE MEDIA RENDERED");
  const gridRef = useRef(null);
  const spaceSideBar = useSelector(selectSpaceSideBar);
  const meSharing = useSelector(selectMeSharing);
  const portalNodesRefs = useMemo(() => {
    let portalNodesRefs = [];
    for (let i = 0; i <= MAX_PEOPLE_IN_SPACE; i++) {
      portalNodesRefs.push(
        createHtmlPortalNode({
          attributes: {
            id: `mediaContainer${i.toString()}`,
            class: REMOTE_VIDEO_CONTAINER,
          },
        })
      );
    }
    return portalNodesRefs;
  }, []);

  let smallRefs = [];
  let bigRefs = [];
  let inPortals = [];

  // Do this to stop re-renders when its just the same thing (since bigLuids is an object)
  let bigPeeps = useSelector((state) => selectBigLuids(state).join("-")).split(
    "-"
  );
  let smallPeeps = useSelector((state) =>
    selectSmallLuids(state).join("-")
  ).split("-");
  // When none it will be [""]
  if (!bigPeeps[0]) bigPeeps = [];
  if (!smallPeeps[0]) smallPeeps = [];

  bigPeeps.forEach((luid) => {
    inPortals.push(
      <InPortal node={portalNodesRefs[parseInt(luid)]} key={luid}>
        <MediaContainer
          luid={luid}
          elem={portalNodesRefs[parseInt(luid)].element}
        />
      </InPortal>
    );
    bigRefs.push(portalNodesRefs[parseInt(luid)]);
  });
  smallPeeps.forEach((luid) => {
    inPortals.push(
      <InPortal node={portalNodesRefs[parseInt(luid)]} key={luid}>
        <MediaContainer
          luid={luid}
          elem={portalNodesRefs[parseInt(luid)].element}
        />
      </InPortal>
    );
    smallRefs.push(portalNodesRefs[parseInt(luid)]);
  });

  useEffect(() => {
    window.addEventListener("resize", throttleGridResize);
    window.addEventListener("load", throttleGridResize);
    throttleGridResize();
    return () => {
      window.removeEventListener("resize", throttleGridResize);
      window.removeEventListener("load", throttleGridResize);
    };
  }, []);

  return (
    <>
      {inPortals}
      <div
        id={GRIDMEN_CONTAINER}
        className={`gridmen ${spaceSideBar ? "side-bar-enlarged" : ""} `}
        ref={gridRef}
      >
        {meSharing === "board" && <MyBoard />}
        <BigVideoCloser />
        <div style={{ display: "none" }}></div>
        <RenderedOutPortals portalRefs={bigRefs} />
        <div style={{ display: "none" }}></div>
      </div>
      <div style={{ display: "none" }}></div>
      {/* These divs before and after help insure that reverse portals can have a 
      div to go off when appending to the list when things change 
      ("insertBefore" command requires a reference point)*/}
      <RenderedOutPortals portalRefs={smallRefs} />
      <div style={{ display: "none" }}></div>
    </>
  );
};
export default RemoteMedia;
